import { Input } from "antd";
import { useContext, useEffect, useState } from "react";
import MPageHeader from "../../../../component/PageHeader";
import { SpinContext } from "../../../../component/Spin/spin.context";
import { spinActions } from "../../../../component/Spin/spin.reducer";
import { MPagination } from "../../../../helper/pagination";
import { RouteContext } from "../../user/screen/components/route.context";
import { Customer, CustomerInquiry } from "../entity/customer.model";
import { customerService } from "../service/customer.service";
import CustomerTable from "./component/CustomerTable";

function Customers() {
  const { dispatch } = useContext(SpinContext);
  const { state } = useContext(RouteContext);
  const [customerPagination, setCustomerPagination] = useState<
    MPagination<Customer>
  >({
    count: 1,
    results: [],
  });
  const [name, setName] = useState("");
  const [companyCode, setCompanyCode] = useState("");

  const pageChange = (inquiry: CustomerInquiry) => {
    dispatch({ type: spinActions.BLOCK });

    if (name.length > 0) {
      inquiry.name = name;
    }

    if (companyCode.length > 0) {
      inquiry.companyCode = companyCode;
    }

    inquiry.routeId = state.routeId;

    customerService
      .getCustomers({
        ...inquiry,
      })
      .then((pagination: MPagination<Customer>) => {
        customerPagination.current = inquiry.page;
        setCustomerPagination(pagination);
        dispatch({ type: spinActions.UNBLOCK });
      })
      .catch(() => {
        dispatch({ type: spinActions.UNBLOCK });
      });
  };

  useEffect(() => {
    let inquiry: CustomerInquiry = {
      page: 1,
      pageSize: 10,
    };

    pageChange(inquiry);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.routeId]);

  const onSubmit = (e: any) => {
    e.preventDefault();

    pageChange({
      page: 1,
      pageSize: 10,
    });
  };

  return (
    <>
      <MPageHeader crumbs={["Харилцагчид"]} />
      <div className="content">
        <div className="card">
          <div className="card-header">
            <h6 className="card-title">Харилцагчид</h6>
          </div>
          <div className="card-body">
            <div className="mb-2">
              <form onSubmit={onSubmit}>
                <Input
                  allowClear
                  style={{ width: "236px" }}
                  value={name}
                  placeholder="Нэрийг оруулна уу"
                  onChange={(e) => setName(e.target.value)}
                />
                <Input
                  allowClear
                  className="ml-2"
                  style={{ width: "236px" }}
                  value={companyCode}
                  placeholder="Харилцагчийн кодыг оруулна уу"
                  onChange={(e) => setCompanyCode(e.target.value)}
                />
                <button type="submit" className="btn btn-sm btn-primary ml-2">
                  <i className="icon-search4 mr-2" />
                  Хайх
                </button>
              </form>
            </div>

            <CustomerTable
              onChange={(page: number, pageSize: number) => {
                pageChange({ page, pageSize });
              }}
              pagination={customerPagination}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default Customers;
